module.exports = __webpack_public_path__ + "static/super-admin-tax-list-1405d81be5e75df3f2540eb12600d39c.png";